import script from "./PartnersParallax.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersParallax.vue?vue&type=script&setup=true&lang=js"

import "./PartnersParallax.vue?vue&type=style&index=0&id=2295470e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2295470e"]])

export default __exports__